export const deepSet = <T extends Record<any, any>>(
  obj: T,
  path: string | string[],
  value: any,
): T => {
  // Regex explained: https://regexr.com/58j0k
  const pathArray = Array.isArray(path) ? path : path?.match(/([^[.\]])+/g);

  if (!pathArray) {
    throw new Error('Invalid path');
  }

  const newObj: T = { ...obj };
  pathArray.reduce((acc: Record<string, any>, key: string, i: number) => {
    if (acc[key] === undefined) acc[key] = {};
    if (i === pathArray.length - 1) acc[key] = value;
    return acc[key];
  }, newObj);

  return newObj;
};
